export * from 'app/settings/ubolino_app';
